import { apiPost } from '../api'

export const save_permissions = data => {
  return apiPost({
    endpoint: 'user/save_permissions',
    data: data
  })
}
